import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top container">
        <div className="footer-brand">
          <h2 className="footer-logo">📰 NewsBuzz Today</h2>
          <p>Your trusted source for accurate, in-depth, and timely news coverage from across India and the world.</p>
          <div className="social-links">
            <a href="#" aria-label="Facebook">📘</a>
            <a href="#" aria-label="Twitter">🐦</a>
            <a href="#" aria-label="Instagram">📸</a>
            <a href="#" aria-label="YouTube">▶️</a>
          </div>
        </div>
        <div className="footer-links">
          <h4>Sections</h4>
          <ul>
            {['Politics','Sports','Technology','Entertainment','Business','World'].map(c => (
              <li key={c}><Link to={`/category/${c.toLowerCase()}`}>{c}</Link></li>
            ))}
          </ul>
        </div>
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/epaper">E-Paper</Link></li>
            <li><Link to="/about">About Us</Link></li>
          </ul>
        </div>
        <div className="footer-newsletter">
          <h4>Stay Updated</h4>
          <p>Subscribe to our newsletter</p>
          <div className="newsletter-form">
            <input type="email" placeholder="Your email address" />
            <button className="btn btn-primary btn-sm">Subscribe</button>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} NewsBuzz Today. All rights reserved.</p>
        <p className="footer-tagline">Breaking News, Every Moment.</p>
      </div>
    </footer>
  );
}
